var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMasteryPathsLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMasteryPaths",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1892.1 374.226 1517.874 0 1143.76 374.226l78.884 78.884 239.442-239.442v478.996c0 191.464-116.596 261.534-251.715 342.65-91.604 54.895-190.349 114.923-250.377 216.904-59.916-101.98-158.66-162.009-250.265-216.904-135.118-81.116-251.827-151.186-251.827-342.65V213.668L697.456 453.11l78.884-78.884L402.114 0 28 374.226l78.884 78.884 239.442-239.442v478.996c0 254.728 162.678 352.245 306.165 438.27 135.118 81.116 251.715 151.186 251.715 342.762V1920h111.576v-446.304c0-191.576 116.709-261.646 251.827-342.762 143.487-86.025 306.053-183.542 306.053-438.27V213.668l239.554 239.442 78.884-78.884Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMasteryPathsLine.glyphName = 'mastery-paths';
IconMasteryPathsLine.variant = 'Line';
IconMasteryPathsLine.displayName = 'IconMasteryPathsLine';
IconMasteryPathsLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMasteryPathsLine;
export { IconMasteryPathsLine };